<template>
  <b-container fluid>
    <b-spinner v-if="!loaded && loading" big label="Loading..."></b-spinner>
    <div v-else-if="loaded">
      <b-row no-gutters>
        <b-col md="6">
          <h3>Kursant łącznie opłacił {{paidMonthsCount}}</h3>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" @click="addPayment">Dodaj płatność</b-button>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="12" v-for="payment in payments" :key="payment.id">
          <item :payment="payment" @delete="onDelete" />
        </b-col>
      </b-row>
    </div>
    <add-payment-modal ref="addModal" @payment-added="getData()" :userId="id"></add-payment-modal>
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import item from "./DetailsPaymentsItem";
import AddPaymentModal from "./AddPaymentModal";

export default {
  components: { item, AddPaymentModal },
  name: "paymentList",
  data() {
    return {
      payments: [],
      loading: false,
      loaded: false
    };
  },
  mounted() {
    this.loading = true;
    this.getData();
  },
  computed: {
    paidMonthsCount: function() {
      var quantity = this.payments
        .filter(p => p.bookedDate)
        .map(p => p.quantity)
        .reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          0
        );

      if (quantity % 10 === 1) return `${quantity} makrocykl`;

      if (quantity % 10 > 1 && quantity % 10 < 5)
        return `${quantity} makrocykle`;

      return `${quantity} makrocykli`;
    }
  },
  props: ["id"],
  methods: {
    onDelete(guid) {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz usunąć tą płatność?")
        .then(answer => {
          if (answer) {
            return axios
              .delete("payments", {
                params: {
                  guid: guid
                }
              })
              .then(() => {
                eventBus.$emit("notify-success", "Usunięto poprawnie.");
                let index = this.payments.findIndex(p => p.id === guid);
                this.payments.splice(index, 1);
              })
              .catch(err => {
                eventBus.$emit("unhandled-error", err);
              });
          }
        });
    },
    addPayment() {
      this.$refs.addModal.showModal(this.id);
    },
    getData() {
      this.loading = true;
      return axios
        .get("/students/payments", {
          params: {
            id: this.id
          }
        })
        .then(result => {
          this.payments = result.data;
          this.loaded = true;
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  margin-right: 3px;
  margin-bottom: 10px;
}
</style>

